<template>
  <button class="tag"
          @click="clicked" >
    <span class="title">{{ title }}</span>
  </button>
</template>

<script>

export default {
  name: 'Tag',
  props: {
    title: {
      type: String,
      require: true,
    },
  },
  methods: {
    clicked() {
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>

@import '~base-ui/src/scss/riseup-colors';

.tag {

  margin: 5px;
  padding: 5px 15px;
  border-radius: 20px;
  cursor: pointer;
  background-color:transparent;
  border-color: $riseup_black;
  border-width: 1px;

  .title {
    font-family: SimplerPro;
    font-size: 16px;
    line-height: 24px;
    color: $riseup_black;
  }
}
</style>
